/**
 * Calculate elapsed minutes since a given ISO timestamp.
 */
export function elapsedMinutes(since: string | null): number {
  if (!since) return 0;
  const diff = Date.now() - new Date(since).getTime();
  return Math.floor(diff / 60_000);
}

/**
 * Format seconds into MM:SS display string.
 */
export function formatTimer(totalSeconds: number): string {
  const mins = Math.floor(totalSeconds / 60);
  const secs = totalSeconds % 60;
  return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
}

/**
 * Get SLA status based on elapsed time vs estimated prep time.
 * Returns "ok" | "warning" | "overdue"
 */
export function getSLAStatus(
  createdAt: string,
  estimatedPrepMinutes: number | null,
): "ok" | "warning" | "overdue" {
  if (!estimatedPrepMinutes) return "ok";
  const elapsed = elapsedMinutes(createdAt);
  if (elapsed > estimatedPrepMinutes) return "overdue";
  if (elapsed > estimatedPrepMinutes * 0.75) return "warning";
  return "ok";
}
